import React from "react";
import { Phone, Mail, Instagram, Linkedin, Youtube } from "lucide-react";
import { FOOTER } from "@/constants/testIds";
import { SITE } from "@/lib/site";
import DroneLogo from "@/components/DroneLogo";

export const Footer = () => {
  return (
    <footer
      data-testid={FOOTER.root}
      className="relative pt-24 pb-10 border-t border-white/5"
    >
      <div className="mx-auto max-w-7xl px-6">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-[#007AFF]/15 border border-[#007AFF]/40 text-[#007AFF]">
                <DroneLogo size={20} />
              </span>
              <div className="font-display text-lg font-semibold tracking-tight">
                drones<span className="text-[#007AFF]">3x</span>.fr
              </div>
            </div>
            <p className="mt-4 text-white/55 max-w-md text-sm leading-relaxed">
              Entreprise Française de spectacle de drones aériens. Mariages, corporate, festivals, sport —
              partout en France, en Europe et au Maroc.
            </p>
            <div className="mt-6 flex gap-3">
              {[Instagram, Linkedin, Youtube].map((I, i) => (
                <a
                  key={i}
                  href="#"
                  className="inline-flex h-10 w-10 items-center justify-center rounded-full glass hover:bg-white/10 transition"
                  aria-label="social"
                >
                  <I size={16} className="text-white/70" />
                </a>
              ))}
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="text-xs uppercase tracking-[0.25em] text-white/40">Contact</div>
            <ul className="mt-5 space-y-3 text-sm text-white/75">
              <li className="flex items-center gap-3">
                <Phone size={14} className="text-[#007AFF]" />
                <a href={SITE.phoneLink} className="hover:text-white">{SITE.phoneDisplay}</a>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={14} className="text-[#007AFF]" />
                <a href={SITE.emailLink} className="hover:text-white">{SITE.emailDisplay}</a>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-4">
            <div className="text-xs uppercase tracking-[0.25em] text-white/40">
              Villes desservies
            </div>
            <ul className="mt-5 grid grid-cols-2 gap-2 text-sm text-white/70">
              {SITE.cities.slice(0, 10).map((c) => (
                <li key={c}>Spectacle drones {c}</li>
              ))}
            </ul>
          </div>
        </div>

        {/* Massive brand */}
        <div className="mt-20 overflow-hidden">
          <div className="font-display text-[18vw] leading-none font-black tracking-tighter text-white/[0.04] select-none">
            drones3x
          </div>
        </div>

        <div className="mt-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-white/40">
          <div>© {new Date().getFullYear()} drones3x.fr — Tous droits réservés.</div>
          <div className="flex gap-5">
            <a href="#" className="hover:text-white">Mentions légales</a>
            <a href="#" className="hover:text-white">Politique de confidentialité</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
